
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CopyButton',
  data() {
    return { hasCopied: false }
  },
  props: {
    label: {
      type: String,
      default: 'Copy'
    },
    successLabel: {
      type: String,
      default: 'Copied'
    },
    icon: {
      type: String,
      default: 'copy'
    },
    successIcon: {
      type: String,
      default: 'check'
    },
    iconOnly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Number,
      default: 1000
    },
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    btnIcon(): string {
      return this.hasCopied ? this.successIcon : this.icon
    },
    btnLabel(): string | null {
      if (this.iconOnly) {
        return null
      }
      return this.hasCopied ? this.successLabel : this.label
    },
    zButtonBindings(): Record<string, string> {
      const attrsBinding = this.$attrs

      const btnHasType = Object.keys(attrsBinding).includes('buttonType')
      if (!btnHasType) {
        attrsBinding.buttonType = 'secondary'
      }

      const btnHasSize = Object.keys(attrsBinding).includes('size')
      if (!btnHasSize) {
        attrsBinding.size = 'small'
      }

      return attrsBinding
    }
  },
  methods: {
    copyContent(): void {
      if (!this.disabled) {
        this.$copyToClipboard(this.value)
        this.hasCopied = true
        setTimeout(() => {
          this.hasCopied = false
        }, this.timeout)
      }
    }
  }
})
